// a string that is appended to calendarIds that are room resources in gsuite
export const GSUITE_ROOM_ID = "resource.calendar.google.com";

// a prepended string that the BE will add to room resources in m365
export const CW_ROOM_PREPENDED_ID = "cwresource|";

export const roomStrings = [GSUITE_ROOM_ID, CW_ROOM_PREPENDED_ID];

export const isRoom = (str: string) => roomStrings.some((v) => str.includes(v));
